import './index.scss'
$(document).ready(function() {
    if (location.hash) {
        setTimeout(function() {
            var targetOffset = $(location.hash).offset().top;
        console.log(targetOffset)
            $('html, body').animate({
                scrollTop: targetOffset - 100
            }, 500);
        }, 10);
    }
});
$(".history-nav a").click(function() {
    let id = $(this).attr("href").split("#").pop()
    var top = $('#' + id).offset().top;
    console.log(top);
    $('html,body').animate({
        scrollTop: top - 100
    }, 500);
  })